import React, { useState } from "react";
import { FiCheckCircle, FiPlus } from "react-icons/fi";
import { CustomTable, Modal } from "src/component";
import { MdOutlineCancel } from "react-icons/md";
import { UpdatePassword, CreateProfile } from "src/Modal";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getAllAdmin, updateAdminStatus } from "src/services/api";
import { renderAlert, renderConfirmDialogue } from "src/utils/functions";
import { useProtectedRoutesContext } from "src/context/ProtectedRoutes";
import { PiLockKeyLight } from "react-icons/pi";

const AdminProfiles = () => {
  const { user } = useProtectedRoutesContext();

  const [modalOpen, setModalOpen] = useState(false);
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [userData, setUserData] = useState("");

  const { data, refetch } = useQuery({
    queryKey: ["admin"],
    queryFn: getAllAdmin,
    suspense: true,
  });

  const { mutate, isLoading } = useMutation(updateAdminStatus, {
    onSuccess: (res) => {
      renderAlert({
        title: "Success",
        msg: res?.msg,
        type: "success",
      });
      refetch();
    },
  });

  const columns = [
    {
      name: "S/N",
      cell: (_, i) => i + 1,
      width: "5%",
    },
    {
      name: "Name",
      cell: (row) => <div className="capitalize">{row?.name}</div>,
    },

    {
      name: "Email",
      cell: (row) => row?.email,
    },
    {
      name: "Role",
      cell: (row) => (
        <div className="capitalize">{row?.role ? row?.role : "N/A"}</div>
      ),
      width: "10%",
    },
    {
      name: "Status",
      cell: (row) => <div className="capitalize">{row?.status}</div>,
      width: "10%",
    },

    {
      name: "Action",
      cell: (row) => (
        <div className="flex items-center justify-start flex-wrap gap-[1rem]">
          <div
            className="flex items-center justify-start my-1 gap-[.5rem] rounded-[1.2rem] text-[1.4rem]  font-normal cursor-pointer hover:text-defaultPrimary"
            onClick={() => {
              setPasswordModalOpen(true);
              setUserData(row);
            }}
          >
            <PiLockKeyLight size="2rem" />
            Password
          </div>
          {user?.role === "admin" &&
            (row?.role === "admin" ? (
              ""
            ) : row?.status === "active" ? (
              <div
                className="flex items-center justify-start my-1 gap-[.5rem]  rounded-[1.2rem] text-[1.4rem] font-normal cursor-pointer hover:text-defaultPrimary"
                onClick={() => {
                  renderConfirmDialogue(
                    "Are you sure?",
                    "Are you sure you want to deactivate this user?",
                    "Yes, deactivate it!"
                  ).then((confirmed) => {
                    if (confirmed) {
                      mutate({ id: row?.id, status: "deactivated" });
                    }
                  });
                }}
              >
                <MdOutlineCancel size="2rem" />
                Deactivated
              </div>
            ) : (
              <div
                className="flex items-center justify-start my-1 gap-[.5rem]  rounded-[1.2rem] text-[1.4rem] font-normal cursor-pointer hover:text-defaultPrimary"
                onClick={() => {
                  renderConfirmDialogue(
                    "Are you sure?",
                    "Are you sure you want to activate this user?",
                    "Yes, Activate it!"
                  ).then((confirmed) => {
                    if (confirmed) {
                      mutate({ id: row?.id, status: "active" });
                    }
                  });
                }}
              >
                <FiCheckCircle size="2rem" />
                Activate
              </div>
            ))}
        </div>
      ),
      width: "25%",
    },
  ];

  return (
    <>
      <div className="flex items-center justify-between mb-[3rem]">
        <p className="text-[2.5rem] font-medium text-defaultPrimary">
          Profiles
        </p>

        <div className="flex justify-center items-center gap-[3rem]">
          <button
            className="bg-lightPrimary py-[1rem] px-[1.8rem] text-defaultPrimary text-[1.5rem] rounded-lg flex items-center gap-2"
            onClick={() => {
              setModalOpen(true);
            }}
          >
            <FiPlus size={15} />
            Create Profile
          </button>
        </div>
      </div>

      <div>
        <CustomTable
          columns={columns}
          data={data?.data}
          progressPending={isLoading}
        />
      </div>

      <Modal isOpen={modalOpen} setIsOpen={setModalOpen} title="Create Profile">
        <CreateProfile setModalOpen={setModalOpen} refetch={refetch} />
      </Modal>
      <Modal
        isOpen={passwordModalOpen}
        setIsOpen={setPasswordModalOpen}
        title="Update Password"
      >
        <UpdatePassword
          setModalOpen={setPasswordModalOpen}
          refetch={refetch}
          editData={userData}
        />
      </Modal>
    </>
  );
};

export default AdminProfiles;
